/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_2_TitleInputs */

const en_vc_onl_how_2_title = /** @type {(inputs: Vc_Onl_How_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open and save like a desktop app`)
};

const zh_vc_onl_how_2_title = /** @type {(inputs: Vc_Onl_How_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`像桌面软件一样打开和保存`)
};

/**
* | output |
* | --- |
* | "Open and save like a desktop app" |
*
* @param {Vc_Onl_How_2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_2_title = /** @type {((inputs?: Vc_Onl_How_2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_2_title(inputs)
	return zh_vc_onl_how_2_title(inputs)
});
export { vc_onl_how_2_title as "vc.onl.how.2.title" }